export default "__VITE_ASSET__BMJo9aLU__"